import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/JobsPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["jobs"];
  const titleKey = "page.jobs.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "JobsPageBannerSection", props: { variant: "primary" } },
        {
          component: "JobsPageFeedSection",
          props: {
            className: "pb-md-5 mb-4 mb-md-5",
            prefilters: { [sourceflowEnums.categories.sectors.id]: [sourceflowEnums.categories.sectors.external] },
            exclude: {
              [sourceflowEnums.categories.sectors.id]: true,
              [sourceflowEnums.categories.officeLocations.id]: true,
            },
          },
        },
      ],
    },
  };
}
